// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y2TOTwNHD5wHI0oUxsAX {
    background-color: white;
    padding: 16px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}

.czIGyYmT5XFB2Bxr0viO {
    background-color: white;
    padding: 30px 36px;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}

.czIGyYmT5XFB2Bxr0viO h1 {
    font-weight: 600;
    -webkit-font-smoothing: antialiased;
}

@media screen and (min-width: 700px) {
    .czIGyYmT5XFB2Bxr0viO {
        margin: 0px 50px 0;
        border-radius: initial;
    }

    .y2TOTwNHD5wHI0oUxsAX {
        margin: 0 50px 0;
        border-radius: initial;
    }

    .KQvUDtgnnGTqe5sEEgMg {
        height: 100px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/haven-design/card/card.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,aAAa;IACb,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".card {\n    background-color: white;\n    padding: 16px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n}\n\n.containerCard {\n    background-color: white;\n    padding: 30px 36px;\n    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n}\n\n.containerCard h1 {\n    font-weight: 600;\n    -webkit-font-smoothing: antialiased;\n}\n\n@media screen and (min-width: 700px) {\n    .containerCard {\n        margin: 0px 50px 0;\n        border-radius: initial;\n    }\n\n    .card {\n        margin: 0 50px 0;\n        border-radius: initial;\n    }\n\n    .headerSpacer {\n        height: 100px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `y2TOTwNHD5wHI0oUxsAX`,
	"containerCard": `czIGyYmT5XFB2Bxr0viO`,
	"headerSpacer": `KQvUDtgnnGTqe5sEEgMg`
};
export default ___CSS_LOADER_EXPORT___;
